import { DownloadSimpleIcon } from "@phosphor-icons/react/dist/csr/DownloadSimple";
import { useState } from "react";
import { Button } from "@volca/ui/components/ui/button";
import type {
  ApActionType,
  ApDayField,
  ApDayRange,
} from "@/accounts-payable/types";
import { ExportInvoicesDialog } from "./export-invoices-dialog";
import { initialExportOptions } from "./export-options";
import type { InvoiceFilter } from "./use-invoices-tab";

/** Opens the export dialog, seeded with what the list is showing. */
export const ExportInvoicesButton = ({
  businessId,
  statusFilters,
  list,
}: {
  businessId: string | null;
  statusFilters: InvoiceFilter[];
  list: {
    status: string;
    dayField: ApDayField;
    dayRange: ApDayRange | null;
    assigneeTokens: string[];
    search: string;
    actionTypes: ApActionType[];
  };
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        disabled={!businessId}
        onClick={() => setOpen(true)}
      >
        <DownloadSimpleIcon data-icon="inline-start" />
        Export
      </Button>
      {/* Mounted only while open, so each opening starts from the list. */}
      {open && businessId && (
        <ExportInvoicesDialog
          businessId={businessId}
          statusFilters={statusFilters}
          initialOptions={initialExportOptions(list)}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
};
